module.exports = __webpack_public_path__ + "img/IconDeviceTypeWall.878ed67d.png";